import React from 'react';
import propTypes from 'prop-types';
import {connect} from 'react-redux';

//import components
import ItemText from './ItemText.js';
import ItemListInline from './ItemListInline.js';

const ItemOtherNames = ({ clang, list, dateLabel, placesLabel }) => {
    return (
        <div>
            {list.map((listItem, index) =>
                <div key={index}>
                    <div>
                        <div className="item__separate__item">
                            <ItemText text={listItem.label} isTransit={listItem.transliterated} type={listItem.entityType}/>
                        </div>
                        {listItem.periodInfo &&
                            <div className="item__separate__item">
                                <ItemText text={`${dateLabel}: ${listItem.periodInfo}`}/>
                            </div>}
                        {listItem.places && listItem.places.length > 0 &&
                            <div className="item__separate__item">
                                <ItemText text={`${placesLabel}:`}/>
                                <ItemListInline list={listItem.places} />
                            </div>}
                    </div>
                    {index !== list.length - 1 &&
                        <div className="item__subsection">
                            <label className="item__subsection-label__separator">
                            </label>
                            <div className="item__subsection-content">
                            </div>
                        </div>}
                </div>)}
        </div>
    );
};

ItemOtherNames.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemOtherNames);



// WEBPACK FOOTER //
// ./src/components/items/ItemOtherNames.js